/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { CSVLink } from "react-csv"; // CSV export
import { Toaster } from "react-hot-toast";
import Swal from "sweetalert2";
import {
  useAddImportProductMutation,
  useAddProductMutation,
} from "../../services/productApi";
import Header from "../Common/Header/Header";
import SideBar from "../Common/SideBar/SideBar";

import * as Icons from "heroicons-react";
import { ProgressBar } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  resetImport,
  selectfaildData,
  selectprocessedData,
} from "../../features/importSlice";
import { useBrandListQuery } from "../../services/brandApi";
import {
  useCategoryListQuery,
  useMasterCategoryListQuery,
} from "../../services/categoryApi";
import { useUnitListQuery } from "../../services/unitApi";
import CsvDataImporter from "../Common/CsvImporter/CsvDataImporter";
import SelectBrandImport from "../Common/CustomSelect/SelectBrandImport";
import SelectCategoryImport from "../Common/CustomSelect/selectCategoryImport";
import SelectMCImport from "../Common/CustomSelect/selectMCImport";
import SelectUnitImport from "../Common/CustomSelect/selectUnitImport";
import { signInUser } from "../Utility/Auth";
import { notify } from "../Utility/Notify";

const ImportProduct = () => {
  const dispatch = useDispatch();
  const auth = signInUser();
  const { aamarId, warehouse } = auth;
  // console.log("aamarId:", aamarId);
  const data = useSelector((state) => state.importReducer);
  const [isImportedDone, setIsImportedDone] = useState(false);
  const [isUploading, setIsUploading] = useState(false);
  const [uploadCurrent, setUploadCurrent] = useState(0);
  // const [mcId, setMcId] = useState(null);
  const processedData = data?.processedData;
  // const mcIdData = data?.mcId;
  // console.log("mcId send ID", mcIdData);
  const faildData = data?.faildData;
  const csvData = data?.csvData;
  const [isProcess, setIsProcess] = useState(false); // Success Data
  const [pp, setPp] = useState(0); // Process Percent
  const navigate = useNavigate();

  const [AddImportProduct] = useAddImportProductMutation();

  const { data: brands } = useBrandListQuery(aamarId);
  // console.log("brands", brands);
  const { data: masterCategories } = useMasterCategoryListQuery({ aamarId });
  const { data: categories } = useCategoryListQuery({ aamarId });
  // console.log("category", categories);
  const { data: units } = useUnitListQuery();
  const lang = useSelector((state) => state.languageReducer);

  // console.log("csv slice data::>>", data);
  const handleImport = async () => {
    // console.log("Import csv Data", csvData);
    setIsImportedDone(true);
    setIsUploading(true);
    setUploadCurrent(0);

    let newProcessData = [...processedData];
    let newFailedData = [];
    let successCount = 0;
    let failedCount = 0;
    
    let counter = 0;
    console.log("Starting handleImport. Total processedData items:", processedData.length);
    for (const product of processedData) {
      if (
        product?.category !== null &&
        product?.master_category !== null &&
        product?.unit !== null
      ) {
        try {
          console.log(`[Import Loop] Sending product ${counter + 1}/${processedData.length} to API:`, product.name, product);
          //TODO:: Create each product
          const result = await AddImportProduct(product);
          console.log(`[Import Loop] API response for "${product.name}":`, result);

          if (result?.data) {
            successCount++;
            newProcessData = newProcessData.map((p) =>
              p.article_code === product?.article_code
                ? { ...p, isImport: true }
                : p
            );
          } else {
            failedCount++;
            const backendError = result?.error?.data?.error || result?.error?.data?.message || "Product Import Failed";
            newFailedData.push({
              name: product?.name,
              category: product?.category,
              master_category: product?.master_category,
              tp: product?.tp,
              mrp: product?.mrp,
              stock: product?.stock,
              article_code: product?.article_code,
              ean: product?.ean,
              unit: product?.unit,
              brand: product?.brand,
              status: product?.status || "active",
              type: product?.type,
              remarks: backendError,
            });
          }
        } catch (err) {
          failedCount++;
          newFailedData.push({
            name: product?.name,
            category: product?.category,
            master_category: product?.master_category,
            tp: product?.tp,
            mrp: product?.mrp,
            stock: product?.stock,
            article_code: product?.article_code,
            ean: product?.ean,
            unit: product?.unit,
            brand: product?.brand,
            status: product?.status || "active",
            type: product?.type,
            remarks: err?.message || "Product Import Failed",
          });
        }
      } else {
        failedCount++;
        let missingFields = [];
        if (product?.master_category === null) missingFields.push("Category");
        if (product?.category === null) missingFields.push("Sub Category");
        if (product?.unit === null) missingFields.push("Unit");
        
        console.warn(`[Import Loop] Pre-validation failed for "${product.name}". Missing fields:`, missingFields, "Row details:", product);
        newFailedData.push({
          name: product?.name,
          category: product?.category,
          master_category: product?.master_category,
          tp: product?.tp,
          mrp: product?.mrp,
          article_code: product?.article_code,
          ean: product?.ean,
          shipping_method: product?.shipping_method,
          unit: product?.unit,
          alert_quantity: product?.alert_quantity,
          brand: product?.brand,
          vat: product?.vat,
          status: product?.status || "active",
          type: product?.type,
          remarks: `Missing configurations in DB for: ${missingFields.join(", ")}`,
        });
      }
      counter++;
      setUploadCurrent(counter);
    }
    dispatch(selectfaildData(newFailedData));
    dispatch(selectprocessedData(newProcessData));
    setIsUploading(false);

    if (failedCount > 0) {
      Swal.fire({
        title: "Import Completed with Errors",
        html: `Successfully imported <b>${successCount}</b> products.<br/>
               Failed to import <b>${failedCount}</b> products.<br/><br/>
               Please download the failed products report below to view details.`,
        icon: "warning",
        confirmButtonText: "Close"
      });
    } else {
      Swal.fire({
        title: "Success",
        text: "All products imported successfully!",
        icon: "success",
        confirmButtonText: "Done"
      });
    }
  };

  const processCsvData = async (csvData) => {
    dispatch(selectprocessedData([]));
    dispatch(selectfaildData([]));
    let oldData = [];

    console.log("--- Starting CSV processing in processCsvData ---");
    console.log("Raw CSV Data:", csvData);
    console.log("Reference lists available in component state:", {
      brandsCount: brands?.length,
      categoriesCount: categories?.length,
      masterCategoriesCount: masterCategories?.length,
      unitsCount: units?.length
    });
    
    let i = 1;
    for (const product of csvData) {
      const brandId = getBrandIdbyName(product?.brand);

      // Helper to find field value across possible column names
      const findField = (keys) => {
        for (const k of keys) {
          if (product[k] !== undefined && product[k] !== null && String(product[k]).trim() !== "") {
            return String(product[k]).trim();
          }
          const matched = Object.keys(product).find(
            (key) => key.trim().toLowerCase().replace(/[\s_-]+/g, "") === k.toLowerCase().replace(/[\s_-]+/g, "")
          );
          if (matched && product[matched] !== undefined && product[matched] !== null && String(product[matched]).trim() !== "") {
            return String(product[matched]).trim();
          }
        }
        return "";
      };

      const explicitSubCatName = findField([
        "sub_category",
        "subcategory",
        "sub category",
        "Sub Category",
        "SubCategory",
        "sub_cat",
        "subCat",
      ]);

      const explicitMasterCatName = findField([
        "master_category",
        "mastercategory",
        "master category",
        "Master Category",
        "MasterCategory",
      ]);

      const genericCatName = findField(["category", "Category", "CATEGORY"]);

      let matchedMC = null;
      let matchedCat = null;

      // 1. Resolve Master Category (Category in UI)
      if (explicitMasterCatName) {
        matchedMC = masterCategories?.find(
          (mc) => mc?.name?.trim()?.toLowerCase() === explicitMasterCatName.trim().toLowerCase()
        );
      }
      if (!matchedMC && genericCatName) {
        matchedMC = masterCategories?.find(
          (mc) => mc?.name?.trim()?.toLowerCase() === genericCatName.trim().toLowerCase()
        );
      }

      // 2. Resolve Sub Category
      if (explicitSubCatName) {
        matchedCat = categories?.find(
          (c) => c?.name?.trim()?.toLowerCase() === explicitSubCatName.trim().toLowerCase()
        );
      }
      if (!matchedCat && genericCatName && matchedMC?.name?.trim()?.toLowerCase() !== genericCatName.trim().toLowerCase()) {
        matchedCat = categories?.find(
          (c) => c?.name?.trim()?.toLowerCase() === genericCatName.trim().toLowerCase()
        );
      }
      if (!matchedCat && explicitMasterCatName && matchedMC?.name?.trim()?.toLowerCase() !== explicitMasterCatName.trim().toLowerCase()) {
        matchedCat = categories?.find(
          (c) => c?.name?.trim()?.toLowerCase() === explicitMasterCatName.trim().toLowerCase()
        );
      }

      // 3. If Sub Category matched, but Master Category didn't, infer parent Master Category
      if (matchedCat && !matchedMC && matchedCat.mc) {
        const parentId = matchedCat.mc?._id || matchedCat.mc;
        matchedMC = masterCategories?.find((mc) => String(mc._id) === String(parentId));
      }

      // 4. If Master Category matched, but Sub Category didn't:
      // Check subcategories under this Master Category in DB
      if (matchedMC && !matchedCat) {
        const subCatsForMC = categories?.filter(
          (c) => String(c.mc?._id || c.mc) === String(matchedMC._id)
        );
        if (subCatsForMC?.length === 1) {
          matchedCat = subCatsForMC[0];
        } else if (subCatsForMC?.length > 1) {
          const pName = (product?.name || "").toLowerCase();
          const nameMatch = subCatsForMC.find((c) => pName.includes(c?.name?.toLowerCase()));
          if (nameMatch) {
            matchedCat = nameMatch;
          }
        }
      }

      const mcId = matchedMC?._id || null;
      const mcName = matchedMC?.name || explicitMasterCatName || genericCatName || "";

      const catId = matchedCat?._id || null;
      const catName = matchedCat?.name || explicitSubCatName || "";
      const unitId = getUnitIdbyName(product?.unit);
      
      console.log(`Row ${i}: "${product?.name}" lookup resolutions:`, {
        brand: { name: product?.brand, resolvedId: brandId },
        masterCategory: { name: mcName, resolvedId: mcId },
        subCategory: { name: catName, resolvedId: catId },
        unit: { name: product?.unit, resolvedId: unitId }
      });

      const newProduct = {
        name: product?.name || "",
        article_code: product?.article_code || "",
        aamarId: aamarId,
        warehouse: warehouse,
        stock: product?.stock || 0,
        category: catId || null,
        categoryName: catName,
        master_category: mcId || null,
        master_categoryName: mcName,
        ean: product?.ean || " ",
        brand: brandId || null,
        brandName: product?.brand,
        tp: product?.tp || "",
        mrp: product?.mrp || "",
        unit: unitId || null,
        status:
          product?.status?.toString().trim().toLowerCase() === "inactive"
            ? "inactive"
            : "active",
        order: i++,
        readyToImport: true,
        isImport: false,
      };
      
      oldData = [...oldData, newProduct];
      pp >= 0 && setIsProcess(false);
      pp === 100 && setIsProcess(false);
    }
    dispatch(selectprocessedData(oldData));
    console.log("--- Finished CSV processing. Total processed items:", oldData.length);
    notify("Product Imported Successfully", "success");
  };

  const getBrandIdbyName = (name) => {
    if (brands) {
      const result = brands?.find(
        (brand) => brand?.name?.toLowerCase() === name?.toLowerCase()
      );
      // console.log("brand result", result);
      return result?._id;
    } else {
      return null;
    }
  };
  const getMasterCategoryIdbyName = (name) => {
    if (masterCategories && name) {
      const cleanName = name.trim().toLowerCase();
      const result = masterCategories?.find(
        (mc) => mc?.name?.trim()?.toLowerCase() === cleanName
      );
      return result?._id;
    } else {
      return null;
    }
  };
  const getCategoryIdbyName = (name) => {
    if (categories && name) {
      const cleanName = name.toString().trim().toLowerCase();
      const result = categories?.find(
        (category) => category?.name?.toString()?.trim()?.toLowerCase() === cleanName
      );
      return result?._id || null;
    } else {
      return null;
    }
  };

  console.log('unit',units)

  const getUnitIdbyName = (name) => {
    if (!units || !name) return null;
    const cleanName = name.toString().trim().toLowerCase();

    // 1. Direct match on name, symbol, or combined "name - symbol"
    let result = units?.find((unit) => {
      const uName = unit?.name?.trim()?.toLowerCase();
      const uSymbol = unit?.symbol?.trim()?.toLowerCase();
      const combined = `${uName} - ${uSymbol}`;
      const combinedNoSpace = `${uName}-${uSymbol}`;

      return (
        uName === cleanName ||
        uSymbol === cleanName ||
        combined === cleanName ||
        combinedNoSpace === cleanName.replace(/\s+/g, "") ||
        (cleanName === "pcs" && uSymbol === "pc") ||
        (cleanName === "pieces" && uName === "piece") ||
        (cleanName === "ltr" && (uSymbol === "l" || uName === "liter"))
      );
    });

    // 2. If name contains hyphen (e.g. "Piece - pc", "Box - bx"), match against each part
    if (!result && cleanName.includes("-")) {
      const parts = cleanName.split("-").map((p) => p.trim());
      result = units?.find((unit) => {
        const uName = unit?.name?.trim()?.toLowerCase();
        const uSymbol = unit?.symbol?.trim()?.toLowerCase();
        return parts.some(
          (p) =>
            p === uName ||
            p === uSymbol ||
            (p === "pcs" && uSymbol === "pc") ||
            (p === "pieces" && uName === "piece") ||
            (p === "ltr" && (uSymbol === "l" || uName === "liter"))
        );
      });
    }

    return result?._id || null;
  };
  // console.log("CSV", processedData);
  useEffect(() => {
    // console.log("csvData Changes");
    if (csvData?.length > 0) {
      if (csvData?.length !== processedData?.length) {
        csvData?.length > 0 && processCsvData(csvData);
      }
    }
  }, [csvData]);
  useEffect(() => {
    if (csvData?.length > 0) {
      const hasUnresolved =
        processedData?.length > 0 &&
        (processedData?.some((p) => p.unit === null && units?.length > 0) ||
         processedData?.some((p) => p.master_category === null && masterCategories?.length > 0) ||
         processedData?.some((p) => p.category === null && categories?.length > 0));
      if (processedData?.length === 0 || hasUnresolved) {
        processCsvData(csvData);
      }
    }
  }, [units, masterCategories, categories]);
  useEffect(() => {
    // console.log("CSV", csvData);
    // console.log("csvData Changes");
    if (csvData?.length > 0) {
      if (csvData?.length !== processedData?.length) {
        csvData?.length > 0 && processCsvData(csvData);
      }
    }
  }, []);
  useEffect(() => {
    setIsProcess(true);
    setPp(0);
    // let progress = 0;
    const processPercent = (100 / csvData?.length) * processedData?.length;

    // console.log("Process Percent");
    setPp(processPercent || 0);
    // setIsProcess(true);
    // csvData.length > 0 && processCsvData(csvData);
  }, [processedData]);

  return (
    <div>
      <div className="container-fluid">
        {isUploading && (
          <div 
            className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center bg-dark bg-opacity-50" 
            style={{ zIndex: 1050 }}
          >
            <div className="bg-white p-4 rounded shadow text-center" style={{ width: "320px" }}>
              <div className="spinner-border text-primary mb-3" role="status"></div>
              <h5>Importing Products</h5>
              <p className="text-muted mb-2">Please do not close this window</p>
              <div className="progress mb-2">
                <div 
                  className="progress-bar progress-bar-striped progress-bar-animated bg-success" 
                  role="progressbar" 
                  style={{ width: `${Math.round((uploadCurrent / processedData.length) * 100)}%` }}
                >
                  {Math.round((uploadCurrent / processedData.length) * 100)}%
                </div>
              </div>
              <small className="text-secondary">{uploadCurrent} of {processedData.length} products processed</small>
            </div>
          </div>
        )}
        <div className="row">
          <div className="col-md-2">
            <SideBar></SideBar>
          </div>
          <div className="col-md-10">
            <Header title={lang?.importProduct}></Header>
            <div className="row">
              <div className="col-md-12 ">
                {csvData?.length === 0 ? (
                  <div
                    className="d-flex justify-content-center align-items-center vh-100 "
                    style={{ marginTop: "-80px" }}
                  >
                    <div className="col-6">
                      <div className="d-flex justify-content-between align-items-center">
                        <div>
                          <p className="p-0 m-0 fw-bold">Import Products</p>
                          <p className="p-0 m-0">
                            <small>
                              Please check the format before uploading
                              <a
                                href="/importSample/importProductSample.csv"
                                download
                                className="text-primary text-opacity-75 text-decoration-none d-inline-flex align-items-center gap-1"
                                style={{ transition: "color 0.3s ease-in-out" }}
                              >
                                <Icons.Download size="15" />
                                Download
                              </a>{" "}
                              the sample file
                              {/* File to check the format before uploading. */}
                            </small>
                          </p>
                        </div>
                      </div>
                      <div>
                        <CsvDataImporter />
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="row">
                    <div className="col-12">
                      <p className="d-flex justify-content-between p-2">
                        Total Product: {csvData?.length}{" "}
                        <span className="input-group-text">
                          <span
                            className="input-group-text gap-2"
                            id="basic-addon1"
                          >
                            {isImportedDone && faildData?.length > 0 && (
                              // TODO:: MAKE THIS BUTTON EXPOrt FAILD

                              <CSVLink
                                data={faildData}
                                filename="failed_products.csv"
                                className="btn btn-dark"
                              >
                                <Icons.Download size="18" /> Export Failed Data
                              </CSVLink>
                            )}
                            {!isImportedDone && (
                              <button
                                onClick={() => handleImport()}
                                className="btn btn-dark btn-block"
                                style={{ zIndex: 0 }}
                              >
                                <Icons.Upload size="18" /> Import Products
                              </button>
                            )}
                            {!isImportedDone && (
                              <button
                                onClick={() => {
                                  processCsvData(csvData);
                                  setIsImportedDone(false);
                                }}
                                className="btn btn-outline-dark btn-block"
                                style={{ zIndex: 0 }}
                              >
                                <Icons.Refresh size="18" /> Reload
                              </button>
                            )}

                            <button
                              onClick={() => {
                                dispatch(resetImport());
                                setIsImportedDone(false);
                              }}
                              className="btn btn-outline-dark btn-block"
                              style={{ zIndex: 0 }}
                            >
                              {!isImportedDone ? "Cancle" : "Import Again"}{" "}
                              <Icons.X size="18" />
                            </button>
                            {isImportedDone && (
                              <button
                                onClick={() => {
                                  dispatch(resetImport());
                                  setIsImportedDone(false);
                                  navigate("/product");
                                }}
                                className="btn btn-outline-success btn-block"
                                style={{ zIndex: 0 }}
                              >
                                <Icons.CheckCircle size="18" /> Done
                              </button>
                            )}
                          </span>
                        </span>
                      </p>
                    </div>
                    {!isProcess ? (
                      <div className="col-md-6 offset-md-3 col-12 ">
                        <div
                          className="d-flex justify-content-center align-items-left flex-column w-100"
                          style={{ height: "60vh" }}
                        >
                          <h3>Processing Data {pp}%</h3>
                          <div className="w-100">
                            <ProgressBar
                              animated
                              striped
                              variant="success"
                              now={pp}
                            />
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div className="col-12 ">
                        <table className="table table-striped">
                          <thead>
                            <tr>
                              <th className="">#</th>
                              <th>Article Code</th>
                              <th>Name</th>
                              <th>EAN</th>
                              <th className="text-center">TP</th>
                              <th>MRP</th>
                              <th>Category</th>
                              <th>Sub Category</th>
                              <th>Brand</th>
                              {/* <th className="text-center">Shipping Method</th> */}

                              <th>Unit</th>
                              {/* <th>Alert Qty</th> */}
                              {/* <th>Vat</th> */}
                              {/* <th>Type</th> */}
                              <th>Status</th>
                            </tr>
                          </thead>
                          <tbody>
                            {processedData?.length > 0 ? (
                              processedData
                                ?.slice()
                                ?.sort((a, b) => a.order - b.order)
                                ?.map((item, index) => (
                                  <tr key={index}>
                                    <th>{index + 1}</th>
                                    <td>{item?.article_code}</td>
                                    <td>{item?.name}</td>
                                    <td>{item?.ean}</td>
                                    <td>{item?.tp}</td>
                                    <td>{item?.mrp}</td>
                                    {/* <td>{item?.master_category}</td> */}
                                    <td>
                                      {masterCategories?.length > 0 ? (
                                        <SelectMCImport
                                          masterCategories={masterCategories}
                                          article_code={item?.article_code}
                                          MCn={item?.master_categoryName}
                                          categoryName={item?.categoryName}
                                        />
                                      ) : (
                                        item?.master_categoryName
                                      )}
                                    </td>
                                    {/* Category */}
                                    <td>
                                      {categories?.length > 0 ? (
                                        <SelectCategoryImport
                                          categories={categories}
                                          article_code={item?.article_code}
                                          categoryName={item?.categoryName}
                                          mcId={item?.master_category}
                                        />
                                      ) : (
                                        item?.categoryName
                                      )}
                                    </td>
                                    {/* <td>{item?.category}</td> */}
                                    {/* <td>
                                      {groups?.length > 0 ? (
                                        <SelectGroupImport
                                          processedData={processedData}
                                          groups={groups}
                                          article_code={item?.article_code}
                                          group={item?.groupName}
                                        />
                                      ) : (
                                        item?.groupName
                                      )}
                                    </td> */}
                                    {/* <td>
                                      {generics?.length > 0 ? (
                                        <SelectGenericImport
                                          processedData={processedData}
                                          generics={generics}
                                          article_code={item?.article_code}
                                          gene={item?.genericName}
                                        />
                                      ) : (
                                        item?.genericName
                                      )}
                                    </td> */}
                                    <td>
                                      {brands?.length > 0 ? (
                                        <SelectBrandImport
                                          processedData={processedData}
                                          brands={brands}
                                          article_code={item?.article_code}
                                          bn={item?.brandName}
                                        />
                                      ) : (
                                        item?.brandName
                                      )}
                                    </td>

                                    {/* <td className="text-center">{item?.shipping_method}</td> */}


                                    <td>
                                      {units?.length > 0 ? (
                                        <SelectUnitImport
                                          processedData={processedData}
                                          units={units}
                                          article_code={item?.article_code}
                                          ut={item?.unit}
                                        />
                                      ) : (
                                        item?.unit
                                      )}
                                    </td>

                                    {/* <td>{item?.alert_quantity}</td>
                                    <td>{item?.vat}</td> */}

                                    {/* <td className="text-center">{item?.vat}</td> */}

                                    {/* <td>{item.type}</td> */}
                                    <td
                                      className={
                                        !isImportedDone
                                          ? "text-success"
                                          : item?.isImport
                                          ? "text-success"
                                          : "text-danger"
                                      }
                                    >
                                      {!isImportedDone
                                        ? "Ready"
                                        : item?.isImport
                                        ? "Done"
                                        : "Failed"}
                                      {/* {item.readyToImport ? "Ready" : "Error"} */}
                                    </td>
                                  </tr>
                                ))
                            ) : (
                              <tr>
                                <td colSpan="15" className="text-center">
                                  No Data Available
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
          <Toaster position="bottom-right" />
        </div>
      </div>
    </div>
  );
};

export default ImportProduct;
